import { Language } from "./language";
import { UserForBackend } from "./user-for-backend";

export class BookingEmailTemplate {

    constructor(
        public id: number | null,
        public name: string,
        public subject: string,
        public body: string,
        public language: Language,
        public createdBy: UserForBackend | null,
        public lastModifiedBy: UserForBackend | null,
        public backgroundColor: string | null
    ){}
}
